import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { LanguageKey } from '../../../../main/translate/language-key/language-key';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'app-button-delete-rounded',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    TooltipModule,
    PipesModule,
  ],
  templateUrl: './button-delete-rounded.component.html',
  styleUrls: ['./button-delete-rounded.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonDeleteRoundedComponent {
  public languageKey = LanguageKey;
}
